module.exports = __webpack_public_path__ + "img/about-us.0c7edbc8.jpg";